import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import googleTagManager from '@analytics/google-tag-manager'

export default function(config) {
    let plugin = null

    const pluginConfig = {
        instanceName: 'rocketeffect',
    }

    switch (config.script_type) {
        case 'ga':
            switch (config.version) {
                case 'universal':
                    plugin = googleAnalyticsV3(Object.assign(pluginConfig, {
                        trackingId: config.id,
                    }))
                    break
                case 'ga4':
                    const localPluginConfig = Object.assign(pluginConfig, {
                        measurementIds: [config.id],
                        dataLayerName: 'dataLayerForRocketEffect',
                        gtagName: 'gtagForRocketEffect',
                    })

                    if (config.debug) {
                        localPluginConfig.debug = true
                    }

                    plugin = googleAnalytics(localPluginConfig)
                    break
                default:
                    return
            }
            break
        case 'gtag':
            plugin = googleTagManager(Object.assign(pluginConfig, {
                containerId: config.id,
                dataLayerName: 'dataLayerForRocketEffect',
                gtagName: 'gtagForRocketEffect',
            }))
            break
        default:
            return
    }

    const analytics = Analytics({
        app: 'Rocket Effect',
        plugins: [plugin],
    })

    analytics.instanceName = pluginConfig.instanceName
    analytics.instancePrefix = pluginConfig.instanceName + '.'

    config.analytics = analytics

    analytics.page()

    return analytics
}
